import React from 'react';
import CSFilterNav from '~/search2/containers/CSFilterNav';
type SearchFacetNavProps = {
  filters: object;
};
const SearchFacetNav: React.SFC<SearchFacetNavProps> = props => {
  const { filters } = props;
  return (
    <div className="grid mt-">
      <div className={'grid__item col-1-1 pl is-showing-1250'}>
        <CSFilterNav filters={filters} />
      </div>
    </div>
  );
};
export default SearchFacetNav;
